import { SnakeIdObj } from '@synapex/tools/typescript';

import { QueryFnData } from '../../../engine';
import { all } from '../key-fn';

type AllData = QueryFnData<typeof all>;

type Account = AllData['advertiserAccounts'][number];
type AccountWorkspace =
  AllData['advertiserAccounts'][number]['workspaces'][number];
type AccountSite = Extract<AccountWorkspace, { workspace_type: 'site' }>;
type WorkspaceSite = Extract<
  AllData['workspaces'][number],
  { workspace_type: 'site' }
>;

export const mapAccount = (
  data: AllData,
  p: SnakeIdObj<'advertiser_account'>,
  mapper: (acc: Account) => Account,
) => ({
  ...data,
  advertiserAccounts: data.advertiserAccounts.map((acc) =>
    acc.advertiser_account_id === p.advertiser_account_id ? mapper(acc) : acc,
  ),
});

export const mapAccountSite = (
  data: AllData,
  p: SnakeIdObj<'advertiser_account' | 'site'>,
  mapper: (site: AccountSite) => AccountSite,
) => ({
  ...data,
  advertiserAccounts: data.advertiserAccounts.map((acc) =>
    acc.advertiser_account_id === p.advertiser_account_id
      ? {
          ...acc,
          workspaces: acc.workspaces.map((ws) =>
            ws.workspace_type === 'site' && ws.site_id === p.site_id
              ? mapper(ws)
              : ws,
          ),
        }
      : acc,
  ),
});

export const mapWorkspaceSite = (
  data: AllData,
  p: SnakeIdObj<'site'>,
  mapper: (site: WorkspaceSite) => WorkspaceSite,
) => ({
  ...data,
  workspaces: data.workspaces.map((ws) =>
    ws.workspace_type === 'site' && ws.site_id === p.site_id ? mapper(ws) : ws,
  ),
});
